import {
  ArrowBefore,
  ArrowForward,
  ArrowNext,
  ArticleGreenIcon,
  CalendarIcon,
  LocalPolice,
  LocationIcon,
  ShoppingCart,
  StarOutline,
  VerifyIcon,
} from "assets/icon";
import { ImageGinsengBG } from "assets/images";
import Footer from "components/Footer";
import Config from "configuration";
import { Slide } from "react-slideshow-image";
import Utils from "utils";
export default function ProductInfoComponent(props) {
  const {
    intl,
    productInfo,
    onPressDispatch,
    onSlideChange,
    progressPercent,
    windowHeight,
  } = props;
  const infoTxt = [
    {
      name: intl.messages.DateOfManufacture,
      icon: <CalendarIcon />,
      value: Utils.formatDateYDM(productInfo?.manufacture_date) ?? "",
    },
    {
      name: intl.messages.Origin,
      icon: <LocationIcon />,
      value: productInfo.source,
    },
    {
      name: intl.messages.Certificate,
      icon: <VerifyIcon />,
      value: productInfo.certificate,
    },
  ];
  const anotherInfo = [
    {
      title: intl.messages.EffectOfGinseng,
      icon: <StarOutline />,
      onPress: () => {
        onPressDispatch("moreInfo");
      },
    },
    {
      title: intl.messages.RelevantCertificate,
      icon: <LocalPolice />,
      onPress: () => {
        onPressDispatch("certificates");
      },
    },
    {
      title: intl.messages.Posts,
      icon: <ArticleGreenIcon />,
      onPress: () => {
        onPressDispatch("news");
      },
    },
    {
      title: intl.messages.PurchaseAddress,
      icon: <ShoppingCart />,
      onPress: () => {
        onPressDispatch("address");
      },
    },
  ];

  const prevArrow = (
    <button className="dot">
      <div className="dot-icon">
        <ArrowBefore />
      </div>
    </button>
  );
  const nextArrow = (
    <button className="dot">
      <div className="dot-icon">
        <ArrowNext />
      </div>
    </button>
  );

  const properties = {
    autoplay: false,
    infinite: true,
    indicators: false,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    onChange: onSlideChange,
  };

  const ProgressBar = () => (
    <div className="progress-container">
      <div className="progress-bar">
        <div
          style={{
            height: "100%",
            width: `${progressPercent}%`,
            backgroundColor: "#fff",
            transition: "width 0.5s",
          }}
        ></div>
      </div>
    </div>
  );

  return (
    <div>
      <div className="product-info-container">
        <h4 className="product-info-title">{productInfo.name}</h4>
        <div className="slide-container">
          <Slide {...properties}>
            {productInfo.product_images.length > 0 &&
              productInfo.product_images.map((item, index) => {
                return (
                  <div className="slide-div" key={`image-${index}`}>
                    <img
                      className="slide-image"
                      alt="slideImage"
                      src={Config.domain + item.images_path}
                    />
                  </div>
                );
              })}
          </Slide>
          <ProgressBar />
          <span className="footer-slide">{intl.messages.MadeFrom}</span>
          {productInfo && (
            <div className="infoTxt">
              <div
                style={{
                  paddingTop: "20px",
                }}
              >
                <p className="product-name-info">
                  {productInfo.secondary_name}
                </p>
                {infoTxt.map((item, index) => (
                  <div
                    key={`infoTxt-${index}`}
                    className="product-info-content"
                  >
                    <span className="product-info-content__icon">
                      {item.icon}
                    </span>
                    <span className="product-info-content__name">
                      {item.name}
                    </span>
                    <span className="product-info-content__value">
                      {Utils.getFirstValueSplit(item.value, ".")}
                    </span>
                  </div>
                ))}
                <div
                  style={{
                    position: "absolute",
                    top: 250,
                    right: 0,
                  }}
                >
                  <img
                    src={ImageGinsengBG}
                    alt="ImageGinsengBG"
                    height={"250px"}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        <Footer
          headerTitle={intl.messages.AnotherInfo}
          isBold
          style={{
            position: `${windowHeight.current <= 750 ? "relative" : "absolute"
              }`,
          }}
        >
          {anotherInfo.map((item, index) => (
            <div style={{ width: "100%" }} key={`anotherInfo-${index}`}>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                {item.icon}
                <span className="footer-title">{item.title}</span>
                <div
                  style={{
                    flex: 1,
                    justifyContent: "flex-end",
                    display: "flex",
                  }}
                >
                  <ArrowForward onClick={item.onPress} />
                </div>
              </div>
              <hr />
            </div>
          ))}
        </Footer>
      </div>
    </div>
  );
}
